import { useEffect } from 'react';
import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useOrgId } from '@/app/session';
import { LoadingState } from '@/components/ui';
import { draftQuery } from '@/features/conversations/drafts';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Old outbox item and tab URLs. A draft id opens its conversation; anything else goes to Conversations. */
export const Route = createFileRoute('/app/outbox/$outboxId')({
  beforeLoad: ({ params }) => {
    if (!UUID.test(params.outboxId)) throw redirect({ to: '/app/conversations', replace: true });
  },
  component: OutboxRedirect,
  staticData: { title: 'Conversations' },
});

function OutboxRedirect() {
  const { outboxId } = Route.useParams();
  const orgId = useOrgId();
  const navigate = useNavigate();
  const draft = useQuery({ ...draftQuery(orgId, outboxId), retry: false });
  const conversationId = draft.data?.conversation_id;
  useEffect(() => {
    if (conversationId) void navigate({ to: '/app/conversations/$conversationId', params: { conversationId }, replace: true });
    else if (draft.isError) void navigate({ to: '/app/conversations', replace: true });
  }, [conversationId, draft.isError, navigate]);
  return <LoadingState label="Opening conversation" />;
}
